// imports
import clsx from 'clsx';
import React from 'react';
import { ICON } from '../../assets';
import PrimaryButton from './primary';

// interfaces / types / consts
interface Props {
  text: string;
  disabled?: boolean;
  type: 'activate' | 'deactivate';
  onClick: () => void;
}

// exports
export default function TokenTransitButton(props: Props): JSX.Element {
  const {
    text, disabled, type, onClick
  } = props;
  // render
  return (
    <PrimaryButton
      text={text}
      size="md-skinny"
      disabled={disabled}
      leftIcon={ICON.ARROW}
      className={clsx('token', type === 'activate' && 'active')}
      onClick={onClick}
    />
  );
}

// default props
TokenTransitButton.defaultProps = { disabled: false };
